{
  "version": 1,
  "asset_id": "362fdaa8-a608-4bb7-8ef5-9fdd87fb869b",
  "project_id": "4dbb42ac-931e-41e9-ac57-3f509e458f26",
  "url": "/__l5e/assets-v1/362fdaa8-a608-4bb7-8ef5-9fdd87fb869b/showcase-placeholder.jpg",
  "r2_key": "a/v1/4dbb42ac-931e-41e9-ac57-3f509e458f26/362fdaa8-a608-4bb7-8ef5-9fdd87fb869b/showcase-placeholder.jpg",
  "original_filename": "showcase-placeholder.jpg",
  "size": 308516,
  "content_type": "image/jpeg",
  "created_at": "2026-09-06T14:43:37Z"
}
